<div class="menu-wrapper-container" [hidden]="hidden">
  <ng-content></ng-content>
</div>
